"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
var middles_1 = require("topology-core/middles");
var class_1 = require("./class");
function register() {
  middles_1.registerNode('simpleClass', class_1.simpleClass, null, class_1.simpleClassIconRect, class_1.simpleClassTextRect);
  middles_1.registerNode('interfaceClass', class_1.interfaceClass, null, class_1.interfaceClassIconRect, class_1.interfaceClassTextRect);
}
exports.register = register;